﻿//@ts-nocheck
export const sideApplyFunctions= () => {

    const sideApply:HTMLElement =  document.querySelector(".job-details__side-apply") 
    const socialWidget: HTMLElement = document.querySelector(".social-share-widget")  
    
    if(!sideApply || !socialWidget) return;
    const sideApplyBottomPosition = sideApply.getBoundingClientRect().bottom + window.scrollY;
    const socialWidgetTopPosition = socialWidget.getBoundingClientRect().top + window.scrollY;

    document.addEventListener("scroll", () => {
    const windowTopPosition = window.scrollY;

    const betweenBounds = betweenBoundsChecker(sideApplyBottomPosition, socialWidgetTopPosition, windowTopPosition);

    if(betweenBounds){
        sideApply.classList.add("sticky");
    } else {
        sideApply.classList.remove("sticky");
    }

})
}



export function betweenBoundsChecker(
    element1BottomPosition: number,
    element2TopPosistion: number,
    element3Position: number
): boolean {
    return element3Position >= element1BottomPosition && element3Position <= element2TopPosistion;
}
